// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { Input } from 'antd'
import Colors from 'components/styles/colors'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import {
  spacing,
  zIndexes,
  fontSize,
} from 'frontend_core/dist/styles/variables'
import Button from 'components/atoms/Button'
import Icon from 'components/atoms/Icon'
import ButtonBase from 'components/atoms/Button/ButtonBase'
import {
  reservationSidebarWidth,
  reservationSidebarWidthTb,
} from 'components/templates/MainContentsWithSidebarInbox'
import { clearFix } from 'components/styles/helpers'

const ContainerHeight = 120
const ContainerHeightSp = 56

const SpacingToSidebarPc = reservationSidebarWidth + spacing.huge
const SpacingToSidebarTb = reservationSidebarWidthTb + spacing.medium_3

const Base = styled.div`
  height: ${ContainerHeightSp}px;
  ${mediaMin.phone`
    height: ${ContainerHeight}px;
  `};
`
const Container = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 -${spacing.medium}px;
  background-color: ${Colors.white};
  z-index: ${zIndexes.baloon};
  ${mediaMin.phone`
    width: calc(100% - ${SpacingToSidebarTb}px);
    max-width: 600px;
    left: ${SpacingToSidebarTb}px;
    margin: 0;
  `} ${mediaMin.desktop`
    width: calc(100% - ${SpacingToSidebarPc}px);
    left: ${SpacingToSidebarPc}px;
  `};
`
const ContentWrapper = styled.div`
  ${clearFix()};
`
const Content = styled.div`
  background-color: ${Colors.white};
  padding: ${spacing.small_2}px;
  ${mediaMin.phone`
    padding: ${spacing.medium}px 0;
  `};
`
const Line = styled.div`
  border-top: 1px solid ${Colors.grayD};
`
const ContainerSp = styled.span`
  display: inline-block;
  ${mediaMin.phone`
    display: none;
  `};
`
const ButtonContainerPc = styled.div`
  display: none;
  ${mediaMin.phone`
    display: inline-block;
  `};
`
const ButtonContainer = styled.div`
  float: right;
  background-color: ${Colors.white};
  ${clearFix()};
  ${mediaMin.phone`
    padding-top: ${spacing.small_2}px;
    text-align: right;
  `};
`
const InputContainerWrapper = styled.div`
  ${mediaMax.phone`
    width: calc(100% - 94px);
    float: left;
  `};
  textarea.ant-input {
    padding: 7px;
  }
`
const InputUpload = styled.input`
  display: none;
`
const Label = styled.label`
  display: inline-block;
`

export type PropTypes = {
  isWithoutSidebar?: boolean,
  buttonsDisable: boolean,
  onChangeText: Function,
  onClickSend: Function,
  messageText: string,
  onClickFile: Function,
  onRefInputFile: Function,
  onChangeFile: Function,
}

const MAX_ROWS = 6
export default (props: PropTypes) => {
  let lines = (props.messageText || '').split('\n').length - 1
  if (lines > MAX_ROWS - 1) lines = MAX_ROWS - 1

  return (
    <div>
      <Container isWithoutSidebar={props.isWithoutSidebar} lines={lines}>
        <Line />
        <Content>
          <ContentWrapper>
            <InputContainerWrapper>
              <Input.TextArea
                autosize={{ maxRows: MAX_ROWS }}
                value={props.messageText}
                placeholder={i18n.t('page.dashboard.reservation.inputMessage')}
                onChange={e => props.onChangeText(e.target.value)}
              />
            </InputContainerWrapper>
            <ButtonContainer>
              <ButtonContainerPc>
                <Label htmlFor="attach_files[]">
                  <InputUpload
                    type="file"
                    accept="image/*,application/pdf"
                    innerRef={props.onRefInputFile}
                    onChange={e => props.onChangeFile(e.target.files[0])}
                    // input[type=file]を描画の度に初期化するためのハック
                    // See: https://github.com/erikras/redux-form/issues/769
                    key={new Date().toString()}
                  />
                  <Button
                    buttonType="onlyIconLarge"
                    tag="button"
                    iconType="fa fa-paperclip"
                    colorType="gray"
                    onClick={props.onClickFile}
                    disabled={props.buttonsDisable}
                  />
                </Label>
                <ButtonBase
                  onClick={props.onClickSend}
                  buttonType="medium"
                  tag="anchor"
                  colorType="blue"
                  buttonMarginPc="0 0 0 8px"
                  buttonHeightPc={40}
                  buttonWidthPc={120}
                  disabled={props.buttonsDisable}
                >
                  {i18n.t('page.shared.send')}
                </ButtonBase>
              </ButtonContainerPc>
              <ContainerSp>
                <Label htmlFor="attach_files[]">
                  <InputUpload
                    type="file"
                    accept="image/*,application/pdf"
                    innerRef={props.onRefInputFile}
                    onChange={e => props.onChangeFile(e.target.files[0])}
                    // input[type=file]を描画の度に初期化するためのハック
                    // See: https://github.com/erikras/redux-form/issues/769
                    key={new Date().toString()}
                  />
                  <Button
                    buttonType="onlyIconLarge"
                    tag="button"
                    iconType="fa fa-paperclip"
                    colorType="gray"
                    onClick={props.onClickFile}
                    disabled={props.buttonsDisable}
                  />
                </Label>
                <Button
                  onClick={props.onClickSend}
                  tag="anchor"
                  buttonType="onlyIconLarge"
                  iconType="fa fa-paper-plane"
                  colorType="blue"
                  buttonHeightPc={40}
                  buttonWidthPc={120}
                  buttonMarginSp="0 0 0 6px"
                  disabled={props.buttonsDisable}
                >
                  <Icon type="paper-plane" positionType="left" />
                </Button>
              </ContainerSp>
            </ButtonContainer>
          </ContentWrapper>
        </Content>
      </Container>
      <Base />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/message/FloatBottom.jsx